import fetch from "lib/fetch"

export const emitEvent = (eventName, parameters = {}) => {
  if (!window.META_PIXEL_CONFIG) return

  const metaPixelId = window.META_PIXEL_CONFIG["id"]
  const metaPixelEnabled = window.META_PIXEL_CONFIG["enabled"]

  if (metaPixelId && metaPixelEnabled) {
    const customParameters = Object.keys(parameters).reduce(
      (s, key) => s + `&cd[${key}]=${parameters[key]}`,
      ""
    )
    fetch(`https://www.facebook.com/tr?id=${metaPixelId}&ev=${eventName}${customParameters}`)
  }
}

const trackPodcastSubscriptionButtons = (iframe) => {
  iframe.contentWindow.postMessage("init", "https://cdn.theconversation.com")

  window.addEventListener("message", (event) => {
    if (event.origin === "https://cdn.theconversation.com" && event.data === "clicked") {
      emitEvent("AddToWishlist")
    }
  })
}

export default function initCustomMetaPixelEvents(contentId) {
  // After 15 seconds we emit a `AddToCard` event, this was changed from
  // the previous `TimeOnPage` and `Lead` event, as Benedictus (the ad agency) was having
  // trouble integrating it into their system (despite originally asking for it).

  if (contentId) {
    setTimeout(() => emitEvent("AddToCart"), 15000)

    // Look for the presence of the podcast iframe, if it's there, track clicks on the subscription buttons
    // this will only work in production due to cross origin messaging limitations with iframes.
    const podcastIframe = document.querySelector("#responsive-tc-infographic-822 iframe")
    if (podcastIframe && document.domain === "theconversation.com") {
      trackPodcastSubscriptionButtons(podcastIframe)
    }
  }
}
